import { SET_CURRENCIES, SET_SELECTED_CURRENCY } from '../actions/types';
import currencyCountries from '../../utils/currencyCountries.json';

const initialState = {
  currencies: [
    {
      currency: 'NOK',
      country: 'NO',
      value: 1,
    },
  ],
  selectedCurrency: {
    currency: 'NOK',
    country: 'NO',
    value: 1,
  },
};

console.log('Currency reducer initialized with state:', initialState);

const currencyReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_CURRENCY:
      console.log('SET_SELECTED_CURRENCY: Changing from', state.selectedCurrency, 'to', action.payload);
      return {
        ...state,
        selectedCurrency: action.payload,
      }
      case SET_CURRENCIES:
        
        // Handle case where payload is undefined or null
        if (!action.payload) {
          console.warn('SET_CURRENCIES: payload is undefined, keeping current currencies');
          return state;
        }
        
        const newCurrencies = currencyCountries.currencies.map(currencyCountry => {
          const conversionRate = action.payload[currencyCountry.currency];
          return {
            ...currencyCountry,
            value: conversionRate || 1, // Default to 1 (NOK base rate) if conversion rate not found
          };
        });
        
        // Check if user has a preferred currency and set it as selected
        let newSelectedCurrency = state.selectedCurrency;
        if (window.userPreferredCurrency) {
          const userPreferred = newCurrencies.find(
            currency => currency.currency === window.userPreferredCurrency
          );
          if (userPreferred) {
            newSelectedCurrency = userPreferred;
            // Clear the temporary storage
            delete window.userPreferredCurrency;
          } else {
            console.warn(`User preferred currency "${window.userPreferredCurrency}" not found in available currencies`);
          }
        }

        return {
          ...state,
          currencies: newCurrencies,
          selectedCurrency: newSelectedCurrency,
      }
    default:
	    return state
  }
};

export default currencyReducer;
